exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-bcabe730],select[data-v-bcabe730]{border-style:solid}", ""]);

// exports
